import React from 'react';

export const CircleCheckSimple = (props) => (
  <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" stroke={props.color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.418 9.992C21.618 9.735 21.987 9.689 22.243 9.889C22.485 10.076 22.54 10.415 22.379 10.668L22.347 10.714L14.11 21.302C13.905 21.567 13.523 21.604 13.27 21.394L13.23 21.357L9.7 17.827C9.471 17.598 9.471 17.226 9.7 16.996C9.917 16.78 10.26 16.766 10.49 16.958L10.533 16.996L13.591 20.054L21.417 9.992H21.418Z"
      fill={props.color}
    />
  </svg>
);
